export const FILTERS = [
  {
    key: "partyType",
    title: "誰と行くか",
    options: [
      { value: "solo", label: "1人" },
      { value: "friends", label: "友人" },
      { value: "couple", label: "カップル" },
      { value: "family", label: "家族" },
    ],
  },
  {
    key: "groupSize",
    title: "人数",
    options: [
      { value: "1", label: "1人" },
      { value: "2", label: "2人" },
      { value: "3", label: "3人" },
      { value: "4", label: "4人" },
      { value: "5+", label: "5人以上" },
    ],
  },
  {
    key: "activity",
    title: "何をしたいか",
    options: [
      { value: "food", label: "食事" },
      { value: "shopping", label: "買い物" },
      { value: "nature", label: "自然" },
    ],
  },
  {
    key: "distance",
    title: "移動イメージ",
    options: [
      { value: "near", label: "近場" },
      { value: "trip", label: "遠出" },
      { value: "either", label: "どちらでも" },
    ],
  },
  {
    key: "transport",
    title: "移動手段",
    options: [
      { value: "car", label: "車" },
      { value: "walk", label: "徒歩" },
      { value: "public", label: "公共交通" },
    ],
  },
  {
    key: "weather",
    title: "天気",
    options: [
      { value: "sunny", label: "晴れ" },
      { value: "rainy", label: "雨" },
      { value: "either", label: "どちらでも" },
    ],
  },
];

export const INTRO_LINES = [
  "新しい週末の冒険を、ひとつ見つけよう。",
  "今日は天の神様に、行き先を任せてみよう。",
  "なんとなくの休日を、ちゃんと楽しい日に。",
  "思いつかない日は、気分で選ぶくらいがちょうどいい。",
  "福岡の気分に合う一手を、軽やかに決めよう。",
  "今日は少しだけ、いつもと違う景色へ。",
];

const near = "near";
const trip = "trip";

const sizesAll = ["1", "2", "3", "4", "5+"];
const sizesGroup = ["2", "3", "4", "5+"];

export const SPOTS = [
  {
    id: "ohori",
    name: "大濠公園",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "池を一周するだけで、なぜか心が整う定番。カップ片手の優雅さも込みです。",
    proposal: "水辺を眺めながら散歩したり、ベンチでぼんやりしたり、カフェで一息ついたり。考えごとを整理したい日にも、家族で軽く出かけたい日にも合います。",
    review: "景色がきれいで、歩くだけでもちゃんと気分転換になるという声が多いです。",
    tags: ["散歩", "定番", "のんびり"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "aburayama",
    name: "油山・油山市民の森",
    area: "福岡市南区",
    pref: "福岡県",
    reason: "市内から少し走るだけで空気が変わります。山が本気を出している場所です。",
    proposal: "展望を見に行ったり、森の中を歩いたり、軽くドライブして景色を楽しんだり。自然の中でリセットしたい日にぴったりです。",
    review: "福岡市内とは思えないくらい空気が変わって、短時間でもリフレッシュできると人気です。",
    tags: ["山", "ドライブ", "自然"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "nokonoshima",
    name: "能古島",
    area: "福岡市西区",
    pref: "福岡県",
    reason: "船に乗った瞬間から旅が始まります。近いのに、行き先はほぼ別世界。",
    proposal: "フェリーで海を渡って、のんびり景色を楽しんだり、花のある季節を狙って歩いたり。写真も気分もちゃんと映える1日になります。",
    review: "福岡からすぐなのに旅に出た感じがして、ちょうどいい非日常だという声が多いです。",
    tags: ["島", "船", "非日常"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "uminonakamichi",
    name: "海の中道海浜公園",
    area: "福岡市東区",
    pref: "福岡県",
    reason: "とにかく広い。持て余すくらいの開放感を、遠慮なく浴びてください。",
    proposal: "自転車を借りたり、花を見たり、芝生でのんびりしたり。天気のいい日に外でしっかり遊びたい時に向いています。",
    review: "一日いても飽きにくくて、外遊びをまとめて楽しめるのがいいと評判です。",
    tags: ["公園", "外遊び", "広い"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "shikanoshima",
    name: "志賀島",
    area: "福岡市東区",
    pref: "福岡県",
    reason: "海沿いを走るだけで満足してしまう、少しずるい道です。",
    proposal: "海を眺めながら走って、景色のいい場所で少し止まり、海鮮やカフェを楽しむ流れが気持ちいいです。",
    review: "気軽なドライブ先として人気で、海の見える景色にちゃんと気分が上がるという声が多いです。",
    tags: ["海", "ドライブ", "景色"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature", "food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "itoshima",
    name: "糸島・桜井二見ヶ浦",
    area: "糸島市",
    pref: "福岡県",
    reason: "海とカフェと写真映え。ひとつも我慢しなくていい欲張りコースです。",
    proposal: "海辺を眺めて、カフェをはしごして、夕方までゆっくり過ごす流れがきれいにハマります。",
    review: "何度行っても景色が気持ちよくて、ちょうどいい週末感があると人気です。",
    tags: ["海", "写真", "カフェ"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature", "food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "shiraito",
    name: "白糸の滝",
    area: "糸島市",
    pref: "福岡県",
    reason: "水の音で街の空気を上書きできます。暑い日はここが正解。",
    proposal: "滝を見に行って空気の違いを感じたり、少し涼みながら自然の中でゆっくりしたり。夏場の気分転換にも向いています。",
    review: "ちゃんと涼しくて、思った以上に癒やされるという感想が多いです。",
    tags: ["滝", "涼しい", "自然"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "lalaport",
    name: "ららぽーと福岡",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "実物大νガンダムが待っています。買い物とごはんは、そのついでに。",
    proposal: "ガンダムを見上げてテンションを上げてから、館内で買い物やごはんを楽しむ流れが鉄板。GODIVA dessert のクレープも気分が上がります。",
    review: "ガンダムのインパクトがやっぱり強くて、普通のモールよりちゃんと特別感があると言われます。",
    tags: ["ガンダム", "グルメ", "買い物"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "food"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "markis",
    name: "MARK IS 福岡ももち",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "雨でも余裕。屋根の下だけで1日が成立してしまう大型施設です。",
    proposal: "買い物をしながらフードコートやカフェで休憩して、周辺の百道エリアまで含めてゆるく一日を組めます。",
    review: "広くて雨の日の逃げ場になりやすく、家族連れでも回しやすいという声が多いです。",
    tags: ["雨OK", "大型施設", "ももち"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "food"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "science-museum",
    name: "福岡市科学館",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "雨の日の切り札。気づくと大人のほうが夢中になっています。",
    proposal: "展示を見たり、体験型コーナーを回ったり、ドームシアターで宇宙や映像の世界に浸ったり。知的だけど堅すぎない遊び方ができます。",
    review: "思ったより大人も楽しめて、雨の日候補としてかなり優秀だと好評です。",
    tags: ["雨OK", "体験", "学び"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["shopping"], 
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "marine-world",
    name: "マリンワールド海の中道",
    area: "福岡市東区",
    pref: "福岡県",
    reason: "天気に関係なく非日常。館内はいつでも海の中です。",
    proposal: "大水槽をゆっくり見たり、イルカやアシカのショーを楽しんだり。海を感じつつ屋内中心で回れるのが強みです。",
    review: "雨でも安心で、子どもも大人もちゃんと見入ってしまうという感想が多いです。",
    tags: ["水族館", "雨OK", "海"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "fantasy-kids",
    name: "ファンタジーキッズリゾート",
    area: "糟屋郡志免町",
    pref: "福岡県",
    reason: "雨の日でも思いきり走り回れる屋内の楽園。親はベンチで待機できます。",
    proposal: "体を動かして遊ばせて、親は見守りながら休憩もできるので、天気が悪い日の逃げ場としてかなり優秀です。",
    review: "長時間でも回しやすくて、雨の日の家族候補として頼れるという声が多いです。",
    tags: ["雨OK", "屋内", "家族向け"],
    who: ["family"],
    size: sizesGroup,
    genres: ["shopping"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "guruguruya",
    name: "ぐるぐる屋(屋内遊園地)",
    sublabel: "例：ぐるぐる屋 箱崎店 など",
    area: "福岡市東区",
    pref: "福岡県",
    reason: "思い立ってすぐ行ける近さ。屋内でしっかり遊べる頼れる味方です。",
    proposal: "屋内で体を使って遊べるので、天気が悪い日でも予定を崩しにくく、家族で回しやすいです。",
    review: "雨の日に困ったらここ系を押さえておくと助かるという実感が強い施設です。",
    tags: ["屋内", "雨OK", "子ども向け"],
    who: ["family"],
    size: sizesGroup,
    genres: ["shopping"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "aeon-fukuoka",
    name: "イオンモール福岡",
    area: "糟屋郡粕屋町",
    pref: "福岡県",
    reason: "ごはんも買い物もここで完結。雨の日の安定感が圧倒的です。",
    proposal: "とりあえず出かけたい日に、食事をして少し見て回って、必要なら子ども向けスペースも使いやすい施設です。",
    review: "迷った日の保険として強くて、家族でも動線が組みやすいと言われます。",
    tags: ["大型モール", "雨OK", "安定"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "food"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "aeon-chikushino",
    name: "イオンモール筑紫野",
    area: "筑紫野市",
    pref: "福岡県",
    reason: "遠出はしたくない、でも出かけたい。そのちょうど中間にあります。",
    proposal: "買い物と食事を無理なく組み合わせて、気負わず半日から一日を組みたい日に使いやすいです。",
    review: "近場すぎず遠すぎずで、気軽に出やすいという声が多いです。",
    tags: ["大型モール", "食事", "近郊"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "food"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "kidzania-like",
    name: "キッザニア福岡",
    sublabel: "例：屋内アスレチック・仕事体験系",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "天気を気にせず1日組めます。子どもの集中力が続くのも強みです。",
    proposal: "体験型で遊べるので、ただ見るだけでは終わらず、しっかり遊んで帰れる日の候補になります。",
    review: "雨の日でも子どもの満足度が高く、親も助かるという声が多いです。",
    tags: ["屋内", "体験", "家族"],
    who: ["family"],
    size: sizesGroup,
    genres: ["shopping"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "daimyo-garden",
    name: "大名ガーデンシティ",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "少し大人の空気。街歩きとごはんの格が、自然に上がります。",
    proposal: "広場の雰囲気を感じながらカフェやレストランに入り、天神・大名エリアの散歩までつなげると気分よく回れます。",
    review: "福岡らしい都会感があって、少し気分を上げたい日にちょうどいいと評判です。",
    tags: ["大人っぽい", "グルメ", "天神近く"],
    who: ["solo", "friends", "couple"],
    size: ["1", "2", "3", "4"],
    genres: ["food", "shopping"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "one-fukuoka",
    name: "ONE FUKUOKA BLDG.",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "新しさが正義。ひとりでもふらっと入れる気楽さがあります。",
    proposal: "館内を見て回って、気になる店に入り、上の方の景色まで含めて都会の空気を楽しむ使い方が似合います。",
    review: "新しい場所を見に行くワクワク感があり、ひとりでも過ごしやすいという声があります。",
    tags: ["新しい", "都会", "1人向き"],
    who: ["solo", "friends", "couple"],
    size: ["1", "2", "3", "4"],
    genres: ["shopping", "food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "tenjin-underground",
    name: "天神地下街",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "雨を完全に無視できる地下の街。濡れずに買い物まで完了します。",
    proposal: "地下街をぶらぶら歩いて、気になる店に入り、カフェで一息。天気に左右されず街歩き気分を味わえます。",
    review: "雨でも気分が落ちにくく、ひとりでも過ごしやすいという感想が多いです。",
    tags: ["雨OK", "街歩き", "天神"],
    who: ["solo", "friends", "couple"],
    size: ["1", "2", "3", "4"],
    genres: ["shopping", "food"],
    transport: ["walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "hakata-city",
    name: "JR博多シティ",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "駅直結。移動の手間がほぼゼロで、食事も買い物も展望もそろいます。",
    proposal: "館内を回ってごはんを食べて、つばめの杜ひろばまで上がれば、街の景色まで楽しめます。",
    review: "アクセスが本当に楽で、予定を立てやすいのが強いという声が多いです。",
    tags: ["駅直結", "食事", "買い物"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["shopping", "food"],
    transport: ["walk", "public", "car"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "canal",
    name: "キャナルシティ博多",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "噴水が勝手にショーを始めます。ただの買い物では終わりません。",
    proposal: "建物の中を歩きながらショップやごはんを楽しみ、タイミングが合えば噴水ショーまで見ると満足感が高いです。",
    review: "キャナルらしい景色がちゃんとあって、観光気分も少し入るのがいいと言われます。",
    tags: ["噴水", "非日常", "博多"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "nakasu-yatai",
    name: "中洲屋台街",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "福岡の夜が、そのまま並んでいます。特別感は最初から確定です。",
    proposal: "屋台の雰囲気を楽しみながら軽く一杯や一品をつまんで、夜の街を歩くだけでも気分が出ます。",
    review: "観光っぽさとローカル感の両方があって、夜のお出かけ先として印象に残ると言われます。",
    tags: ["夜", "福岡らしさ", "屋台"],
    who: ["solo", "friends", "couple"],
    size: ["1", "2", "3", "4"],
    genres: ["food"],
    transport: ["walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "dazaifu",
    name: "太宰府天満宮",
    area: "太宰府市",
    pref: "福岡県",
    reason: "学問の神様に会いに行けます。参道の空気まで含めて全部が主役。",
    proposal: "お参りをして空気を感じたあと、参道で梅ヶ枝餅を食べたり甘いものを楽しんだり。太宰府らしさをちゃんと味わえる時間になります。",
    review: "お参りだけで終わらず、参道の食べ歩きまで含めて満足度が高いという声が多いです。",
    tags: ["ご利益", "定番", "食べ歩き"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature", "food"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "dazaifu-sando",
    name: "太宰府参道食べ歩き",
    area: "太宰府市",
    pref: "福岡県",
    reason: "歩きながら少しずつ。重すぎない食事という高等技術が使えます。",
    proposal: "梅ヶ枝餅やスイーツをつまみながら参道を歩いて、気になる店に寄り道するのがちょうど楽しいです。",
    review: "歩いているだけでわくわくしやすく、気軽な半日プランに向いていると好評です。",
    tags: ["食べ歩き", "甘いもの", "太宰府"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["food"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "zoo",
    name: "福岡市動植物園",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "動物も植物も一気に。外でのんびり1日を使いたい日に向いています。",
    proposal: "動物を見て、植物エリアも歩いて、ゆっくり時間を使うのに向いています。家族でもカップルでも回しやすいです。",
    review: "意外としっかり歩くので、軽いお出かけでも満足感があると言われます。",
    tags: ["動物", "植物", "散歩"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "boss-ezo",
    name: "BOSS E・ZO FUKUOKA",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "攻めた遊びと景色が同居。ここだけ刺激の密度が違います。",
    proposal: "絶景アトラクションや体験系を楽しんで、PayPayドーム周辺までまとめて回るとテンションが上がります。",
    review: "見た目のインパクトがあって、普通のショッピングよりちゃんと遊び感があると人気です。",
    tags: ["体験", "景色", "非日常"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "nature"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "outlet-kitakyushu",
    name: "THE OUTLETS KITAKYUSHU",
    sublabel: "例：ジ アウトレット北九州 など",
    area: "北九州市八幡東区",
    pref: "福岡県",
    reason: "遠出の気分で、買い物に本気を出す日のための場所です。",
    proposal: "少し車を走らせて、開放感のある施設で買い物と食事をまとめて楽しむ流れが作れます。",
    review: "福岡市内のモールより遠出感があって、ちゃんと気分転換になるという声があります。",
    tags: ["遠出", "買い物", "北九州"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "biopark",
    name: "長崎バイオパーク",
    area: "西海市",
    pref: "長崎県",
    reason: "動物との距離が近すぎます。ふつうの動物園の常識は置いていきましょう。",
    proposal: "カピバラやいろいろな動物を近くで見て、ふれあい感のある一日を過ごせます。家族遠出にもかなり相性がいいです。",
    review: "近さに驚くという感想が多く、子どもも大人もちゃんと盛り上がりやすいスポットです。",
    tags: ["動物", "遠出", "ふれあい"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "huis",
    name: "ハウステンボス",
    area: "佐世保市",
    pref: "長崎県",
    reason: "街並みごと非日常。1日まるごと預ける価値があります。",
    proposal: "景色を楽しんで、アトラクションやごはんも入れて、朝から夜まで旅っぽい時間を過ごせます。",
    review: "遠出した満足感が強くて、写真も思い出もちゃんと残るという声が多いです。",
    tags: ["非日常", "遠出", "1日使える"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "nature", "food"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "tenjin-area",
    imageId: "tenjin-area",
    name: "天神エリア",
    sublabel: "例：天神地下街、ソラリア、ワンビル周辺",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "歩いているだけでにぎやか。買い物もごはんも、この一帯で片づきます。",
    proposal: "その日の気分でショップをのぞいたり、カフェで休んだり、デパ地下を見て回ったりしながら、無理なく半日過ごせます。",
    review: "迷ったらとりあえず天神に行けば外しにくい、という声がやっぱり強いです。",
    tags: ["定番", "買い物", "ごはん"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["shopping", "food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "yakuin-cafe",
    imageId: "yakuin-cafe",
    name: "薬院カフェ・ごはん巡り",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "落ち着いた空気の中で、ごはんの時間が少しおしゃれになります。",
    proposal: "カフェでゆっくりしたり、夜は焼肉やビストロに寄ったりと、気分に合わせて大人っぽく過ごせます。",
    review: "天神ほどせわしなくなくて、ちゃんと気分転換になる街だと言われます。",
    tags: ["カフェ", "大人っぽい", "薬院"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "ropponmatsu421",
    imageId: "ropponmatsu421",
    name: "六本松421",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "食事も買い物もコンパクトに。歩く距離が短いのは、それだけでごほうびです。",
    proposal: "館内を軽く見て回って、カフェやスイーツで休みながら、六本松まわりをゆるく歩く流れがちょうどいいです。",
    review: "混みすぎず地味すぎずで、1人でも家族でも使いやすい場所として安定感があります。",
    tags: ["六本松", "カフェ", "ちょうどいい"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["shopping", "food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "acros-fukuoka",
    imageId: "acros-fukuoka",
    name: "アクロス福岡",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "街なかに緑の山。都会と散歩を同時に成立させてしまう建物です。",
    proposal: "天神から歩いて寄って、館内や周辺を見ながらカフェに入ると、都会の中でも少し呼吸が整う時間になります。",
    review: "天神のついでに寄れるのに、気分が切り替わる感じがあると好評です。",
    tags: ["街歩き", "緑", "天神近く"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["shopping", "nature", "food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "fukuoka-tower",
    imageId: "fukuoka-tower",
    name: "福岡タワー・百道",
    area: "福岡市早良区",
    pref: "福岡県",
    reason: "海沿いの開放感で、日常から少しだけ離陸できます。",
    proposal: "海辺を歩いたあとにタワー周辺でごはんにしたり、夕方から夜景までつなげたりすると、デートや家族時間がきれいにまとまります。",
    review: "福岡市内なのにちゃんと非日常感があって、写真もきれいに残ると言われます。",
    tags: ["海沿い", "景色", "百道"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature", "food"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "momochi-beach",
    imageId: "momochi-beach",
    name: "シーサイドももち",
    area: "福岡市早良区",
    pref: "福岡県",
    reason: "海を見ながら歩けます。のんびりしたい日との相性は抜群です。",
    proposal: "海沿いをぶらぶら散歩したり、近くの施設で休憩したりしながら、肩の力を抜いて過ごせます。",
    review: "天気のいい日に行くと、それだけで休日っぽさがかなり出ると好評です。",
    tags: ["海", "散歩", "のんびり"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "maizuru-park",
    name: "舞鶴公園",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "城跡と広場が同居する散歩コース。大濠公園とはまた違う静けさです。",
    proposal: "季節の花や芝生を見ながら散歩したり、近くの天神や大濠につなげて1日を組んだりしやすいです。",
    review: "大濠より少し静かで、のびのび過ごしやすいという人も多いです。",
    tags: ["散歩", "公園", "城跡"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "yanagibashi-market",
    name: "柳橋連合市場",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "市場の活気が、そのまま食欲に変わります。海鮮も惣菜も目の前。",
    proposal: "市場をのぞいて、その場で海鮮やお惣菜を買ったり、周辺のお店でごはんにしたりすると、福岡らしい食の時間になります。",
    review: "観光っぽすぎず、ちゃんと地元感のあるごはん時間が作れるのがいいと言われます。",
    tags: ["市場", "海鮮", "地元感"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "nagahama-market",
    name: "長浜ごはん・市場まわり",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "海鮮にもラーメンにも寄れます。どちらの気分でも受け止めてくれる場所。",
    proposal: "市場まわりで海鮮を楽しんだり、長浜らしい麺ものを食べたりして、福岡ごはんをざっくり満喫できます。",
    review: "観光気分も地元っぽさもほどよく味わえて、食事目的なら満足度が高いと評判です。",
    tags: ["海鮮", "ラーメン", "福岡ごはん"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "daimyo-imaizumi",
    imageId: "daimyo-garden",
    name: "大名・今泉ごはん巡り",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "おしゃれな店が密集。気分を上げると決めた日のためのエリアです。",
    proposal: "カフェ、焼肉、スイーツなどをその日の気分で選びやすく、食後に街歩きまでつなげると満足感が出ます。",
    review: "福岡の街っぽさを感じながらごはんを楽しめる定番エリアとして人気です。",
    tags: ["大名", "今泉", "ごはん充実"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["food", "shopping"],
    transport: ["car", "walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "mojiko-retro",
    name: "門司港レトロ",
    area: "北九州市門司区",
    pref: "福岡県",
    reason: "県内なのに、しっかり旅。港町のレトロが効きすぎています。",
    proposal: "海辺を歩いて、焼きカレーやカフェに寄って、写真を撮りながらのんびり回ると満足度が高いです。",
    review: "福岡県内で遠出感を出したいときの定番として、やっぱり人気があります。",
    tags: ["レトロ", "海辺", "遠出"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food", "shopping", "nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "kokura-castle-town",
    name: "小倉城・小倉まち歩き",
    area: "北九州市小倉北区",
    pref: "福岡県",
    reason: "城を眺めて、街でごはん。1日の組み立てがとても楽になります。",
    proposal: "小倉城周辺を歩いたあとに駅側で買い物や食事を入れると、遠出すぎずちょうどいい1日になります。",
    review: "北九州側で迷ったときに、観光と街歩きのバランスが取りやすいと好評です。",
    tags: ["北九州", "まち歩き", "城"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["shopping", "food", "nature"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "karato-market",
    name: "唐戸市場",
    area: "下関市",
    pref: "山口県",
    reason: "目的は海鮮、以上。潔い日ほど満足度が跳ね上がります。",
    proposal: "海鮮をつまみながら市場を歩いて、海辺の景色まで楽しむと、遠出した意味がちゃんと出ます。",
    review: "海鮮目当てで行くと満足度が高く、つい写真も撮りたくなると人気です。",
    tags: ["海鮮", "市場", "遠出"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["food"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "tsunoshima",
    name: "角島ドライブ",
    area: "下関市",
    pref: "山口県",
    reason: "海の色が少し反則です。遠出した甲斐が、橋の上で確定します。",
    proposal: "ドライブを楽しみながら景色のいい場所で止まって、写真を撮ったり海を眺めたりするだけで十分気分が上がります。",
    review: "写真で見た通りのきれいさで、遠出してよかったと思いやすい場所です。",
    tags: ["海", "ドライブ", "絶景"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "beppu-onsen",
    name: "別府温泉",
    area: "別府市",
    pref: "大分県",
    reason: "疲れを湯に預けにいく日。難しいことは何も考えなくて大丈夫。",
    proposal: "温泉に入って、ごはんを食べて、湯けむりの街を少し歩くだけでもちゃんと満たされる遠出になります。",
    review: "何もしすぎない贅沢ができるので、大人の遠出としてかなり安定感があります。",
    tags: ["温泉", "のんびり", "遠出"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food", "nature"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "yufuin",
    name: "由布院",
    area: "由布市",
    pref: "大分県",
    reason: "街歩き・景色・ごはんが全部そろう優等生。遠出先としては鉄板です。",
    proposal: "通りをゆっくり歩いて、カフェやスイーツに寄りながら、由布岳の景色まで楽しむと満足感が出ます。",
    review: "遠出っぽさがちゃんとあるのに歩きやすくて、初めてでも回りやすいと好評です。",
    tags: ["街歩き", "スイーツ", "温泉地"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food", "shopping", "nature"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "kurokawa-onsen",
    name: "黒川温泉",
    area: "阿蘇郡",
    pref: "熊本県",
    reason: "山あいの静かな温泉街。日常がちゃんと遠のいていきます。",
    proposal: "温泉めぐりをしながら、少し散歩して甘いものを食べるだけでも、遠出した価値がしっかり出ます。",
    review: "しっとりした空気が心地よくて、のんびり派には特に評判がいいです。",
    tags: ["温泉", "山あい", "静か"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["food", "nature"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "aso-drive",
    name: "阿蘇ドライブ",
    area: "阿蘇市",
    pref: "熊本県",
    reason: "スケールが規格外。景色を浴びに行く、それだけで十分な理由です。",
    proposal: "景色のいい場所で止まりながらドライブして、ごはんやソフトクリームをはさむと1日がしっかり特別になります。",
    review: "ただ走るだけでも気持ちが切り替わるので、遠出候補としてかなり人気です。",
    tags: ["ドライブ", "山", "景色"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature", "food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "kumamoto-castle-town",
    name: "熊本城・城下町",
    area: "熊本市",
    pref: "熊本県",
    reason: "観光としての分かりやすさが強い。ごはんも街歩きも迷いません。",
    proposal: "熊本城を見たあとに城下町側で食事や甘いものを楽しむと、観光っぽさもごはん時間も両立できます。",
    review: "遠出先として分かりやすく、家族でもカップルでも組み立てやすいと人気です。",
    tags: ["城", "まち歩き", "遠出"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["food", "shopping", "nature"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "ureshino-onsen",
    name: "嬉野温泉",
    area: "嬉野市",
    pref: "佐賀県",
    reason: "温泉とやさしい街並み。力を抜くことに集中できます。",
    proposal: "温泉に入って、湯どうふやスイーツを楽しみながら、のんびり歩くくらいがちょうどいいです。",
    review: "派手すぎないのにちゃんと満足感があって、落ち着いた遠出として評判です。",
    tags: ["温泉", "湯どうふ", "のんびり"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food", "nature"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "takeo-onsen",
    name: "武雄温泉エリア",
    area: "武雄市",
    pref: "佐賀県",
    reason: "温泉に図書館に街歩き。遠出の欲張りを、きれいに満たしてくれます。",
    proposal: "温泉や館内スポットを見て回って、カフェやごはんをはさみながらゆるく過ごすと気持ちよく回れます。",
    review: "落ち着いた遠出がしたい日にちょうどよく、混みすぎにくいのも好印象と言われます。",
    tags: ["温泉", "街歩き", "佐賀"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food", "shopping", "nature"],
    transport: ["car"],
    weather: ["sunny", "rainy"],
    mode: trip,
  },
  {
    id: "yakuin-park",
    imageId: "yakuin-park",
    name: "薬院・平尾の公園散歩",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "人混みを回避しつつ、街の近くでリズムよく歩けます。",
    proposal: "近場の公園をゆっくり回って、帰りにカフェでひと休みすると気分が整いやすいです。",
    review: "遠くに行かなくてもちゃんとリフレッシュできると好評です。",
    tags: ["散歩", "落ち着く", "近場"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "tenjin-rooftop",
    imageId: "tenjin-rooftop",
    name: "天神の屋上・テラス巡り",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "買い物の合間に外の空気。屋上は、意外と空いています。",
    proposal: "館内のテラスで休みつつ、街歩きとカフェを組み合わせると無理なく回れます。",
    review: "天神に行くなら屋上で一息つくのが意外と良いという声が多いです。",
    tags: ["天神", "テラス", "気分転換"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["shopping", "food"],
    transport: ["walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "ropponmatsu-cinema",
    imageId: "ropponmatsu421",
    name: "六本松シネマ・文化ゾーン",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "映画とカフェをまとめて回収。落ち着いた1日の組み立て方です。",
    proposal: "映画の前後に軽く食事やスイーツを入れると、ゆったりした休日になります。",
    review: "騒がしすぎないので大人っぽい時間を過ごしやすいと言われます。",
    tags: ["映画", "カフェ", "六本松"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["food", "shopping"],
    transport: ["walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "fukuoka-gourmet-street",
    imageId: "hakata-city",
    name: "博多駅グルメ街",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "迷う時間はゼロ。移動も最小限で、ごはんへ直行できます。",
    proposal: "駅で集まってサクッと食事、そこから買い物や街歩きに繋げやすいです。",
    review: "集合も解散も楽なので、友人とのごはん候補として便利と言われます。",
    tags: ["博多", "ごはん", "集合しやすい"],
    who: ["friends", "couple", "family"],
    size: sizesAll,
    genres: ["food"],
    transport: ["public", "walk"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "itohama-drive",
    imageId: "itoshima",
    name: "糸島ドライブ（海沿い）",
    area: "糸島市",
    pref: "福岡県",
    reason: "走るだけで気分が上がる王道ルート。目的地は途中で決めても大丈夫。",
    proposal: "景色のいい場所で写真を撮りつつ、カフェや海鮮で休憩を入れると満足度が高いです。",
    review: "迷ったら糸島ドライブ、というくらい安定感があると人気です。",
    tags: ["ドライブ", "海沿い", "景色"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature", "food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "momochi-dinner",
    imageId: "momochi-dinner",
    name: "百道の夜ごはん",
    area: "福岡市早良区",
    pref: "福岡県",
    reason: "海が近いというだけで、夜ごはんが少し特別になります。",
    proposal: "夕方から海辺を散歩して、そのままごはんに繋げると自然に良い時間になります。",
    review: "いつもの食事でも景色で気分が上がると好評です。",
    tags: ["夜ごはん", "海沿い", "雰囲気"],
    who: ["friends", "couple"],
    size: sizesAll,
    genres: ["food"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "hakata-riverwalk",
    imageId: "hakata-riverwalk",
    name: "川沿いナイト散歩",
    area: "福岡市博多区",
    pref: "福岡県",
    reason: "夜景がきれいです。食後の散歩としては、かなり贅沢な部類。",
    proposal: "中洲・キャナルあたりを軽く歩いて、夜の雰囲気を楽しむと気分が整います。",
    review: "ごはんのあとに少しだけ歩きたい日にちょうどいいと言われます。",
    tags: ["夜景", "散歩", "博多"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "sasebo-drive",
    imageId: "huis",
    name: "佐世保ドライブ",
    area: "佐世保市",
    pref: "長崎県",
    reason: "遠出した実感がしっかり出て、景色もごはんも取りこぼしません。",
    proposal: "景色のいい道を走って、現地でごはんを食べて帰るだけでも満足感が高いです。",
    review: "日帰りでも遠出感が出るので、しっかり気分転換できると評判です。",
    tags: ["ドライブ", "遠出", "長崎"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature", "food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "fukuoka-onsen",
    name: "福岡近郊の温泉・サウナ",
    sublabel: "例：二日市温泉・筑紫野の日帰り湯 など",
    area: "筑紫野市",
    pref: "福岡県",
    reason: "遠出はせずに、疲れだけ置いてくる。時短で整いたい日の選択肢です。",
    proposal: "温泉やサウナで整えて、ごはんを食べて帰るだけでも休日感が出ます。",
    review: "移動が少ないのに満足感があると好評です。",
    tags: ["温泉", "サウナ", "近場"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food", "nature"],
    transport: ["car", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "nishi-park",
    name: "西公園",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "高台から博多湾を一望。桜の季節は、少し得した気分になります。",
    proposal: "坂を上って展望広場まで行くと、街と海がまとめて見えます。春は桜、それ以外の季節も静かに歩ける公園です。",
    review: "街なかからすぐなのに景色が開けていて、得した気分になるという声が多いです。",
    tags: ["公園", "桜", "展望"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "shinoguri-forest",
    name: "篠栗九大の森",
    area: "糟屋郡篠栗町",
    pref: "福岡県",
    reason: "水辺に立つ木々が絵になりすぎる、静かな穴場です。",
    proposal: "池のまわりの遊歩道を1周するだけでも空気が変わります。写真を撮りながらゆっくり歩くのがちょうどいい場所です。",
    review: "静かで人が多すぎず、思っていたより幻想的だったという感想が目立ちます。",
    tags: ["公園", "写真", "静か"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "island-city-park",
    name: "アイランドシティ中央公園",
    area: "福岡市東区",
    pref: "福岡県",
    reason: "芝生が広い。子どもが全力で走っても、まだ余ります。",
    proposal: "芝生でのんびりしたり、体験学習施設をのぞいたり。天気のいい日にお弁当を持っていくと気持ちよく過ごせます。",
    review: "広くて開放感があり、混みすぎないのがいいという声が多いです。",
    tags: ["公園", "芝生", "家族向け"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "hanabatake-park",
    name: "花畑園芸公園",
    area: "福岡市南区",
    pref: "福岡県",
    reason: "果樹と花を眺めながら、静かに散歩できます。しかも無料です。",
    proposal: "園内をゆっくり歩いて、季節の花や果樹を見て回るだけでも気分が切り替わります。混みにくいのでのんびりしたい日に向いています。",
    review: "人が少なくて落ち着けるので、ひとり時間にもいいと言われます。",
    tags: ["公園", "静か", "散歩"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "miyajidake",
    name: "宮地嶽神社",
    area: "福津市",
    pref: "福岡県",
    reason: "参道の先に海。カメラを構えたくなる景色が待っています。",
    proposal: "お参りをして、参道の階段から海に向かう景色を眺めます。門前の松ヶ枝餅を食べて帰る流れが定番です。",
    review: "景色と参道の雰囲気がよくて、ドライブがてら寄りやすいと人気です。",
    tags: ["神社", "写真", "海が見える"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature", "food"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "sarakurayama",
    name: "皿倉山",
    area: "北九州市八幡東区",
    pref: "福岡県",
    reason: "夜景がきれいすぎます。登った価値が、一瞬で回収されます。",
    proposal: "夕方に上がって、日が沈むところから夜景までを続けて見るのがおすすめです。ケーブルカーで上がれるので歩き通しにはなりません。",
    review: "写真で見るより実際のほうがきれいだった、という感想が多い場所です。",
    tags: ["夜景", "展望", "遠出"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "kawachi-fujien",
    name: "河内藤園",
    area: "北九州市八幡東区",
    pref: "福岡県",
    reason: "藤のトンネルが圧巻。写真の満足度が、ひとつ上の階へ行きます。",
    proposal: "藤の時期と紅葉の時期だけ開いている場所です。入園には事前のチケットが必要なので、行く前に必ず公式の案内を確認してください。",
    review: "季節が合えば一番きれいだったと言われるくらい、景色のインパクトが強い場所です。",
    tags: ["写真", "季節限定", "遠出"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "nakanoshima-park",
    name: "中ノ島公園(那珂川)",
    area: "那珂川市",
    pref: "福岡県",
    reason: "浅瀬で水遊び。夏の近場候補としては、かなりの実力者です。",
    proposal: "川べりにレジャーシートを広げて、子どもは浅いところで水遊び。木陰が多いので夏でも過ごしやすい場所です。",
    review: "市内から近いのにしっかり川遊びができて、夏の定番になっているという声が多いです。",
    tags: ["川遊び", "夏", "家族向け"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "choon-falls",
    name: "調音の滝公園",
    area: "うきは市",
    pref: "福岡県",
    reason: "滝のそばだけ涼しさが別格。夏の川遊びにちょうどいい距離感です。",
    proposal: "滝を見て涼んだあと、浅い流れで水遊び。夏場はそうめん流しをやっている時期もあるので、公式の案内を見てから行くと確実です。",
    review: "水がきれいで涼しく、夏に行くと満足度が高いと評判です。",
    tags: ["川遊び", "滝", "夏"],
    who: ["friends", "couple", "family"],
    size: sizesGroup,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "akizuki",
    name: "秋月城下町",
    area: "朝倉市",
    pref: "福岡県",
    reason: "静かな城下町と川辺の景色。時間の流れが、ゆるやかになります。",
    proposal: "杉の馬場をゆっくり歩いて、町のお店で葛のスイーツを食べ、川辺で少し休むと落ち着いた1日になります。",
    review: "人が多すぎず、のんびり歩けるのがいいという声が多いです。",
    tags: ["街歩き", "川遊び", "静か"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature", "food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "hyuganami",
    name: "日向神峡",
    area: "八女市",
    pref: "福岡県",
    reason: "岩とダム湖の景色が独特。ドライブの目的地として申し分なしです。",
    proposal: "湖沿いを走りながら、奇岩やハート岩の見えるところで車を止めて景色を楽しみます。紅葉の時期はとくにきれいです。",
    review: "知名度のわりに景色がよく、静かに過ごせるのがいいと言われます。",
    tags: ["渓谷", "ドライブ", "写真"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "fukuoka-parco",
    name: "福岡PARCO・天神ビッグバンエリア",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "新店と期間限定が集まる場所。話題に追いつきたい日はここへ。",
    proposal: "館内を見て回りながら、話題のポップアップや新しいカフェをのぞきます。天神地下街ともつながっているので雨の日でも動けます。",
    review: "行くたびに新しい店ができていて、見て回るだけでも楽しいという声が多いです。",
    tags: ["天神", "話題の店", "雨OK"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["shopping", "food"],
    transport: ["walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "kego-keyaki",
    name: "警固・けやき通りのカフェ巡り",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "映えるカフェが並びます。街歩きの気分が、そのまま上がります。",
    proposal: "けやき通り沿いを歩きながら、気になったカフェに入ります。天神からも歩けるので、買い物のあとにつなげやすいです。",
    review: "おしゃれな店が多く、ゆっくりできる場所を見つけやすいと人気です。",
    tags: ["カフェ", "話題の店", "街歩き"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["food", "shopping"],
    transport: ["walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "haruyoshi",
    name: "春吉・清川の夜ごはん",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "路地に小さな名店が点在。夜が少しだけ大人になります。",
    proposal: "路地裏の店をのぞきながら、その日の気分でごはんを決めます。中洲や天神からも歩ける距離なので、二軒目にもつなげやすいです。",
    review: "観光地っぽさが少なく、地元の空気で食事ができるのがいいと言われます。",
    tags: ["夜", "隠れ家", "話題の店"],
    who: ["solo", "friends", "couple"],
    size: sizesAll,
    genres: ["food"],
    transport: ["walk", "public"],
    weather: ["sunny", "rainy"],
    mode: near,
  },
  {
    id: "itoshima-cafe",
    name: "糸島の海カフェ巡り",
    area: "糸島市",
    pref: "福岡県",
    reason: "海の見える席が、当たり前のようにあります。写真も気分も満タン。",
    proposal: "海沿いを走りながら気になるカフェに寄って、景色を見ながらゆっくりします。夕方の時間に合わせると景色がとくにきれいです。",
    review: "海を見ながら過ごせる時間そのものがよくて、また行きたくなると評判です。",
    tags: ["カフェ", "海", "写真"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "hirao-bakery",
    name: "平尾・高砂のパン屋巡り",
    area: "福岡市中央区",
    pref: "福岡県",
    reason: "小さなパン屋を歩いて回る、香ばしい遠征です。",
    proposal: "何軒か買い歩いて、近くの公園やカフェで食べ比べます。午前中のほうが種類がそろっていることが多いです。",
    review: "静かな街並みを歩きながら回れて、ひとりでも気楽だと好評です。",
    tags: ["パン", "街歩き", "話題の店"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["food"],
    transport: ["walk", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "kamado-jinja",
    name: "宝満宮竈門神社",
    area: "太宰府市",
    pref: "福岡県",
    reason: "縁結びで有名。モダンな社務所と紅葉が、写真を勝手に決めてくれます。",
    proposal: "お参りをして、ガラス張りの社務所やお守りを見てから、山の景色を眺めます。紅葉の時期はとくにきれいです。",
    review: "神社なのに洗練された雰囲気があって、写真を撮りたくなるという声が多いです。",
    tags: ["映え", "神社", "紅葉"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "nanzoin",
    name: "南蔵院",
    area: "糟屋郡篠栗町",
    pref: "福岡県",
    reason: "世界最大級のブロンズ涅槃像。実物の大きさに、言葉が一度止まります。",
    proposal: "涅槃像を近くで見上げて、境内をゆっくり歩きます。写真では伝わらない大きさなので、行く価値があります。",
    review: "想像よりずっと大きくて、思わず写真を撮ってしまうという感想が多いです。",
    tags: ["映え", "大仏", "近場"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "chinkaiseki",
    name: "鎮懐石八幡宮",
    area: "糸島市",
    pref: "福岡県",
    reason: "海へ伸びる階段が主役。一枚撮れたら、その日は大成功です。",
    proposal: "階段の上から海を眺めて写真を撮り、そのまま糸島の海沿いドライブにつなげると気持ちよく回れます。",
    review: "写真で見たままの景色が撮れて、糸島に来た感じがちゃんとすると人気です。",
    tags: ["映え", "海", "写真"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "keya-no-oto",
    name: "芥屋の大門",
    area: "糸島市",
    pref: "福岡県",
    reason: "海に開いた巨大な洞窟。糸島の自然が本気を出している場所です。",
    proposal: "展望台から岬を眺めるほか、時期が合えば遊覧船で洞窟の近くまで行けます。運航は海の状況で変わるので事前に確認を。",
    review: "自然のスケールがすごくて、糸島の中でも印象に残ったという声が多いです。",
    tags: ["映え", "海", "自然"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "munakata-taisha",
    name: "宗像大社",
    area: "宗像市",
    pref: "福岡県",
    reason: "世界遺産の静けさ。境内に入ると、自然と背筋が伸びます。",
    proposal: "本殿をお参りして、参道や高宮祭場まで歩きます。神宝館まで見るとしっかり半日使えます。",
    review: "空気が澄んでいて、ただのお参り以上の時間になるという感想が多いです。",
    tags: ["映え", "神社", "世界遺産"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car", "public"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "hiraodai",
    name: "平尾台",
    area: "北九州市小倉南区",
    pref: "福岡県",
    reason: "石灰岩の草原が広がります。福岡とは思えない一枚が撮れます。",
    proposal: "台地の道をドライブしながら景色のいい場所で止まり、草原を少し歩きます。鍾乳洞に入ることもできます。",
    review: "国内とは思えない景色だと言われることが多い、知る人ぞ知る場所です。",
    tags: ["映え", "絶景", "ドライブ"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "yame-chaen",
    name: "八女中央大茶園",
    area: "八女市",
    pref: "福岡県",
    reason: "見渡すかぎりの茶畑。スケール感だけで写真が勝ちます。",
    proposal: "展望所から一面の茶畑を眺めます。新茶の時期の緑がとくにきれいで、近くでお茶を買って帰るのも楽しみのひとつです。",
    review: "写真で見るより広くて、思わず何枚も撮ってしまうという声が多いです。",
    tags: ["映え", "茶畑", "絶景"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
  {
    id: "raizan-sennyoji",
    name: "雷山千如寺大悲王院",
    area: "糸島市",
    pref: "福岡県",
    reason: "樹齢400年を超える大楓。紅葉の時期は、景色のほうが圧倒してきます。",
    proposal: "本堂から大楓を眺めて、境内をゆっくり歩きます。紅葉の時期は拝観の受付方法が変わることがあるので、事前に確認してください。",
    review: "紅葉の時期に行くと、写真より実物のほうがきれいだったと言われます。",
    tags: ["映え", "紅葉", "季節限定"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: near,
  },
  {
    id: "sanren-suisha",
    name: "朝倉の三連水車",
    area: "朝倉市",
    pref: "福岡県",
    reason: "今も現役で回っています。日本の原風景が、そこで働いています。",
    proposal: "水車の周りを歩いて景色を眺めます。回っているのは農業用水を使う夏の時期が中心なので、時期を確認してから行くと確実です。",
    review: "実際に回っているところを見ると、思っていたより見応えがあると言われます。",
    tags: ["映え", "水車", "季節限定"],
    who: ["solo", "friends", "couple", "family"],
    size: sizesAll,
    genres: ["nature"],
    transport: ["car"],
    weather: ["sunny"],
    mode: trip,
  },
];

export function getSpotDecisionInfo(spot) {
  const tags = spot.tags || [];
  const has = (...names) => names.some((n) => tags.includes(n));
  const indoor = spot.weather?.includes("rainy") || has("雨OK", "屋内", "大型モール", "水族館", "映画");
  const food = spot.genres?.includes("food");
  const shopping = spot.genres?.includes("shopping");
  const nature = spot.genres?.includes("nature");
  const carOnly = spot.transport?.length === 1 && spot.transport.includes("car");
  const publicAccess = spot.transport?.includes("public") || spot.transport?.includes("walk");
  const farTrip = spot.mode === trip;
  const river = has("川遊び", "水遊び", "渓谷");
  const onsen = has("温泉", "サウナ");
  const walkOutside = nature && !indoor;

  return {
    address: `${spot.pref} ${spot.area}`,
    mapQuery: `${spot.name} ${spot.area} ${spot.pref}`,
    officialUrl: spot.officialUrl || `「${spot.name} 公式」で検索`,
    officialSearchUrl: `https://www.google.com/search?q=${encodeURIComponent(`${spot.name} ${spot.area} 公式`)}`,
    fee: shopping || food ? "飲食・買い物代が中心" : nature ? "無料〜施設利用料" : "施設ごとに確認",
    hours: indoor ? "屋内施設は公式の営業時間を確認" : "日中から夕方の明るい時間が安心",
    duration: farTrip ? "半日〜1日" : indoor ? "2〜4時間" : "1〜3時間",
    access: carOnly ? "車での移動が安心" : publicAccess ? "公共交通や徒歩でも動きやすい" : "車か公共交通かを事前に確認",
    crowd: has("定番", "大型施設", "博多", "天神") ? "週末の昼は混みやすい" : "比較的ゆっくり過ごせる",
    rainy: indoor ? "雨の日でも大丈夫" : spot.weather?.includes("rainy") ? "小雨なら楽しめる" : "晴れの日向き",

    // ここから下はスポットの種類に合わせて内容を変える(全スポット共通の定型文にしない)
    bring: river
      ? "タオルと着替え、脱げにくいサンダル。日よけと飲み物も忘れずに"
      : onsen
        ? "タオルは現地で借りられることが多いですが、あると安心です"
        : walkOutside
          ? "歩きやすい靴と日よけ。夏は虫よけと飲み物があると快適です"
          : indoor
            ? "館内は冷房が効くので、羽織るものが1枚あると安心です"
            : "歩きやすい靴だと動きやすいです",
    safety: river
      ? "雨のあとは水が増えて危ないので入らないでください。子どもから目を離さないように"
      : farTrip
        ? "天気と交通の乱れ、帰りの時間を出発前に確認しておくと安心です"
        : "天気が荒れそうな日は、出発前に公式のお知らせを確認してください",
    onsite: carOnly
      ? "駐車場の場所と料金を、着く前に地図アプリで見ておくとスムーズです"
      : publicAccess
        ? "最寄り駅やバス停からの道は、地図アプリで先に見ておくと迷いません"
        : "行き方は地図アプリで先に確認しておくと安心です",
    reservation: food
      ? "人気の店は混みやすいので、営業時間と予約ができるかを先に確認してください"
      : indoor
        ? "イベントの日は整理券が出ることがあるので、公式のお知らせを確認してください"
        : "季節のイベント時期は駐車場が混みやすいので、早めの時間がおすすめです",
  };
}